<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>


                    <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off" style="width: 100%;">
                    <!-- Row -->
                        <div class="row">

                            <!-- Dashboard Box -->
                            <div class="col-xl-5 col-lg-5 col-xs-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">lock</i> Senha</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xl-12 col-md-6 col-lg-12 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Senha atual</h5>
                                                    <input type="password" class="with-border" placeholder="Informe sua senha atual" v-model="form.senhaAtual">
                                                </div>
                                            </div>

                                            <div class="col-xl-12 col-md-6 col-lg-12 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Nova senha</h5>
                                                    <input type="password" class="with-border" placeholder="Informe sua nova senha" v-model="form.senha">
                                                </div>
                                            </div>

                                            <div class="col-xl-12 col-md-6 col-lg-12 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Confirmar nova senha</h5>
                                                    <input type="password" class="with-border" placeholder="Informe sua nova senha novamente" v-model="form.senhaConfirmacao">
                                                </div>
                                            </div>

                                            <div class="col-xl-12 margin-bottom-20">
                                                <button type="submit" class="button big block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                    <i class="material-icons">save</i>
                                                    Salvar alterações
                                                </button>
                                            </div>
                                            
                                        </div>

                                    </div>
                                </div>
                            </div>  
                            
                            <!-- Button -->

                        </div>
                    </form>                    
                        
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name: 'AlterarSenha',
    components: {
        'Top': Top,
        'Sidebar': Sidebar,
        'Toolbar': Toolbar
    },       
    data () {
        var self                    = this;
        return {
            loading: {
                "submit":           false,
            },
            form: {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "senhaAtual":       "",
                "senha":            "",
                "senhaConfirmacao": ""
            }            
        }
    },
    methods: {
        submit: function(e) {
            var self            = this;
            console.log("submit", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
            
            axios.put("api/alterar-senha.php", self.form)
            .then(response => {
                self.loading.submit = false;
                window.location.reload();
                console.log("ok", response)
                loading.hide();
                alert(response.data.message);
             
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert(error.response.data.message || "Erro! Por favor, tente novamente.");
            });

        }
    },    
    mounted: function() {
        loading.hide();
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AlterarSenha.vue